import classes from "./Header.module.css";

const Header = () => {
  return <span className={classes.header}>🎬 BlueOne Entertainment 🎥</span>;
};

export default Header;
